import { Utility } from 'src/app/core/interceptor/utility';

export class User {
  id: number;
  firstName: string;
  lastName: string;
  name: string;
  username: string;
  password: string;
  email: string;
  createdAt?: string;
  phone: string;
  landlinePhone: string;
  gender: 'male' | 'female';
  nationalId: number;
  foreignerId: string;
  nationalIdImage: string;
  googleAuthEnabled: boolean;
  provinceId: number;
  cityId: number | undefined;
  address: string;
  homeBill?: string;
  postalCode: string;
  birthday: string | undefined;
  identityImage?: string;
  faceImagePath?: string;
  identityVideo?: string;
  nationalCardImage: string;
  feePercent: number | null;
  settings!: {
    name: string;
    value: boolean;
  }[];
  scopes: string[];
  card: string;
  iban: string;
  addressVerified: 'NOT_STARTED' | 'PENDING' | 'ACCEPTED' | 'REJECTED' = 'NOT_STARTED';
  bankVerified: 'NOT_STARTED' | 'PENDING' | 'ACCEPTED' | 'REJECTED';
  emailVerified: 'NOT_STARTED' | 'PENDING' | 'ACCEPTED' | 'REJECTED';
  identityCardVerified: 'NOT_STARTED' | 'PENDING' | 'ACCEPTED' | 'REJECTED';
  identityVerified: 'NOT_STARTED' | 'PENDING' | 'ACCEPTED' | 'REJECTED';
  phoneVerified: 'NOT_STARTED' | 'PENDING' | 'ACCEPTED' | 'REJECTED';
  landlinePhoneVerified: 'NOT_STARTED' | 'PENDING' | 'ACCEPTED' | 'REJECTED';
  defaultTransactionFee: number;
  active: boolean;

  constructor(input: any = {}) {
    this.id = input.id;
    this.firstName = input.first_name;
    this.lastName = input.last_name;
    this.username = input.username;
    this.password = input.password;
    this.email = input.email;
    this.phone = input.phone;
    this.landlinePhone = input.landline_phone;
    this.identityVideo = input.identity_video_path;
    this.gender = input.gender;
    this.nationalId = input.national_id;
    this.foreignerId = input.foreigner_identification;
    this.faceImagePath = input.face_image_path;
    this.provinceId = input.province_id;
    this.cityId = input.city_id;
    this.homeBill = input.home_bill_path;
    this.identityImage = input.identity_path;
    this.nationalCardImage = input.national_id_path;
    this.birthday = input.birthday;
    this.address = input.address;
    this.postalCode = input.postal_code;
    this.name = input.name;
    this.nationalIdImage = input.national_id_image;
    this.feePercent = input.fee_percent === null ? null : +input.fee_percent;
    this.defaultTransactionFee = +input.default_transaction_percent;
    this.addressVerified = input.address_verified ?? 'NOT_STARTED';
    this.bankVerified = input.bank_verified ?? 'NOT_STARTED';
    this.emailVerified = input.email_verified ?? 'NOT_STARTED';
    this.addressVerified = input.address_verified ?? 'NOT_STARTED';
    this.identityVerified = input.identity_verified ?? 'NOT_STARTED';
    this.identityCardVerified = input.identity_card_verified ?? 'NOT_STARTED';
    this.phoneVerified = input.phone_verified ?? 'NOT_STARTED';
    this.landlinePhoneVerified = input.landline_phone_verified ?? 'NOT_STARTED';
    this.settings = input.settings;
    this.scopes = input.scopes;
    this.active = input.active;
    this.googleAuthEnabled = !!input.google_auth_enabled;
    Object.assign(this, Utility.camelize(input));
    if (this.feePercent === null) {
      this.feePercent = this.defaultTransactionFee;
    }
    this.card = input.card?.match(/.{1,4}/g)?.join(' - ');
    this.iban = input.iban;
    if (input.user_id) {
      this.id = input.user_id;
    }
  }
}

export enum SupportRequestsStatus {
  PENDING = 'PENDING',
  VERIFYING = 'VERIFYING',
  REJECTED = 'REJECTED',
  INPROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
}

export class MemoRecoveryRequestModel {
  id: number;
  user: User;
  videoUrl: string;
  currency: string;
  userMemo: string;
  sourceWallet: string;
  networkId: string;
  transactionHash: string;
  destinationWallet: string;
  feeTransactionLink: string;
  isAccessToOldSourceWallet: boolean;
  status: SupportRequestsStatus;
  description: string;

  constructor(input: any = {}) {
    this.id = input.id;
    this.user = new User(input.user);
    this.status = input.status;
    this.videoUrl = input.input.filePath;
    this.currency = input.input.currency;
    this.userMemo = input.input.userMemo;
    this.sourceWallet = input.input.sourceWallet;
    this.networkId = input.input.networkId;
    this.transactionHash = input.input.transactionHash;
    this.destinationWallet = input.input.destinationWallet;
    this.feeTransactionLink = input.input.feeTransactionLink;
    this.isAccessToOldSourceWallet = !!(+input.input.isAccessToOldSourceWallet);
    this.description = input.description;
  }
}

export class TotpRecoveryRequestModel {
  id: number;
  user: User;
  videoUrl: string;
  status: SupportRequestsStatus;
  userRequestDescription!: string;
  description: string;

  constructor(input: any = {}) {
    this.id = input.id;
    this.user = new User(input.user);
    this.status = input.status;
    this.videoUrl = input.input.filePath;
    this.description = input.description;
    this.userRequestDescription = input.input.description;
  }
}

export class BlockWithdrawModel {
  id: number;
  expireAt: string;
  reason: string;
  user: User;

  constructor(input: any = {}) {
    this.id = input.id;
    this.user = new User(input.user);
    this.expireAt = input.expireAt;
    this.reason = input.reason;
  }
}
